import { z } from 'my-zod'
import { vehiclesModel } from '../vehicle'
import { vehicleDispositionsModel } from './vehicle-dispositions-model'

export const vehicleDispositionSystemView = vehicleDispositionsModel.augment({
  vehicleLifecycleStatus: vehiclesModel.shape.lifecycleStatus,
  vehicleVin: vehiclesModel.shape.vin,
  openBulletins: z.number().nonnegative()
})
export type vehicleDispositionSystemView = z.infer<typeof vehicleDispositionSystemView>
